import type { SVGProps } from 'react';
const SvgFlashAuto = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#flash_auto_svg__a)">
      <path
        fill="currentColor"
        d="M3 2v12h3v9l7-12H9l4-9H3Zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2Zm-2.15 5.65L18 4l1.15 3.65h-2.3Z"
      />
    </g>
    <defs>
      <clipPath id="flash_auto_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFlashAuto;
